module.exports = __webpack_public_path__ + "static/img/coaching-sst.a0f87fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/Especialidades/coaching-sst.png
// module id = EGmC
// module chunks = 0